<template>
  <div v-if="client != null">
    <router-view />
    <AutoSaveLoader :autoSaving="autoSaving" />
    <Notepad />
  </div>
</template>

<script>
  import { EventBus }   from '@/shared/event-bus';
  import AutoSaveLoader from '@/shared/components/loaders/AutoSaveLoader'
  import Notepad        from './Notepad'

  export default {

    components: {
      AutoSaveLoader,
      Notepad,
    },

    data () {
      return {
        client    : null,
        autoSaving: false,
      }
    },

    mounted() {
      EventBus.$on('set-autosave', trueOrFalse => {
        this.autoSaving = trueOrFalse
      });
    },

    destroyed() {
      EventBus.$off('set-autosave')
    },

    created() {
      this.getClient({
        clientId : this.$route.params.clientId
      }, (client) => {
        this.client = client
      })
    },
  }
</script>